/**
 * Determines how the availability of a vehicle category asset is derived
 */
export enum VehicleCategoryAvailabilityModeEnum {
	ALWAYS_AVAILABLE = 'always-available',
	NEVER_AVAILABLE = 'never-available',
	DERIVED_FROM_VEHICLES = 'derived-from-vehicles',
}
